"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var next_1 = require("@alifd/next");
var gpyUtils_1 = require("./gpyUtils");
var contextManage_1 = require("../../contextManage");
// 非通用高拍仪对话框组件
var OldGpy = function (props) {
    var context = react_1.useContext(contextManage_1.DeviceTaskContext);
    var _a = react_1.useState(false), loading = _a[0], setLoading = _a[1];
    react_1.useEffect(function () {
        try {
            if (props.gpyInstance) {
                deviceStart(props.gpyInstance);
            }
        }
        catch (error) {
            console.log(error);
            next_1.Message.error(error);
        }
    }, []);
    react_1.useEffect(function () {
        //清楚外层dialog宽高，让其自适应内部高拍仪视频流大小
        context.setWidth("600px");
        context.setHeight("360px");
        //componentWillUnmount 关闭设备
        return function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    if (props.gpyInstance) {
                        gpyUtils_1.stopDevice(props.gpyInstance);
                    }
                }
                catch (error) {
                    next_1.Message.error(error);
                }
                return [2 /*return*/];
            });
        }); };
    }, []);
    var deviceStart = function (gpyInstance, selectedVideo) { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, gpyUtils_1.startDevice(gpyInstance, selectedVideo)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    next_1.Message.error("摄像头启用失败，请重试！");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    //采集按钮
    var okHanlder = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, gpyUtils_1.capture(props.gpyInstance)];
                case 2:
                    res = _a.sent();
                    console.log("capture res: ", res);
                    if (res) { //返回 URL 表示采集成功
                        console.log("caputre url:", res);
                        context.success([res]);
                        closeHandler();
                    }
                    else {
                        next_1.Message.error("采集失败，请重试！");
                    }
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.log("error: ", error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    //停止高拍仪并关闭对话框 - 遗留问题，无法在点击右上角的关闭按钮时调用停用高拍仪
    var closeHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            context.closeDialog();
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginLeft: "-20px", marginTop: "-20px", position: "relative" } },
            React.createElement("div", { style: { width: "598px", height: "350px", border: "1px solid black", float: "left", overflow: "hidden" } },
                React.createElement("div", { style: { width: "100%", height: "100%" } },
                    React.createElement("canvas", { id: "canvas", style: { display: 'none' } }),
                    gpyUtils_1.domRender(props.gpyInstance)('create_view'),
                    React.createElement("div", { style: { width: "100%", height: "100%" } }, gpyUtils_1.domRender(props.gpyInstance)('create_instnce'))))),
        React.createElement("div", { className: "center", style: { position: "absolute", top: "320px", left: "260px", zIndex: 9999 } },
            React.createElement(next_1.Button, { type: "primary", onClick: okHanlder, loading: loading, disabled: loading }, "\u91C7\u96C6"))));
};
exports.default = OldGpy;
